import {  Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TranslatePipe } from '@ngx-translate/core';

import { MpsLoaderService } from '../../services/mps-loader.service';

@Component({
  selector: 'mps-loader',
  templateUrl: './mps-loader.component.html',
  styleUrl: './mps-loader.component.scss',
  imports: [MatProgressSpinner, AsyncPipe, TranslatePipe],

  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MpsLoaderComponent {
  loader = inject(MpsLoaderService);
}
